import "core-js/modules/es6.array.some";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _regeneratorRuntime from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.string.starts-with";
import _slicedToArray from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.regexp.search";
import _toConsumableArray from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import e from "query-string";
import { isPlainObject as n, uniqueId as t, camelCase as l, castArray as o, pairsEq as r } from "tiny-compose-fns";

function i(e, n, t) {
  return n in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}

function u(e, n) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    n && (l = l.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, l);
  }

  return t;
}

var d = function d(e) {
  return e.replace(/(^\/|\/$)/g, "");
},
    v = function v(e) {
  var n = [];
  return e.forEach(function (e) {
    return Array.isArray(e) ? n.push.apply(n, _toConsumableArray(e)) : n.push(e);
  }), n;
},
    s = function s(e) {
  var n = "object" == typeof e && null !== e ? Object.keys(e) : e;
  return (null == n ? void 0 : n.length) ? e : void 0;
},
    c = function c(e) {
  return /^\/(?!\/)/.test(e);
},
    a = "undefined" != typeof window,
    p = function p(e) {
  return "home" === e ? null : e;
},
    f = function f(e) {
  var n;
  return (null == e ? void 0 : e.uid) ? p(null == e ? void 0 : e.uid) : (null == e ? void 0 : e.slug) || (null == e ? void 0 : null === (n = e.slugs) || void 0 === n ? void 0 : n.length) ? g(e) : void 0;
},
    g = function g(e) {
  var n, t;
  return (null == e ? void 0 : e.slug) ? p(null == e ? void 0 : e.slug) : (null == e ? void 0 : null === (n = e.slugs) || void 0 === n ? void 0 : n.length) ? p(null == e ? void 0 : null === (t = e.slugs) || void 0 === t ? void 0 : t[0]) : (null == e ? void 0 : e.uid) ? f(e) : void 0;
},
    h = function e(n) {
  var t;
  var l = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
      o = null == n ? void 0 : null === (t = n.data) || void 0 === t ? void 0 : t.parent;

  if (o && o.hasOwnProperty("value") && (l = !0), l) {
    var r, i;

    var _t = g(n);

    return (o = null === (r = o) || void 0 === r ? void 0 : null === (i = r.value) || void 0 === i ? void 0 : i.document) ? v([e(o, l), _t]).filter(Boolean) : [_t].filter(Boolean);
  }

  {
    var _t2 = f(n);

    return o ? v([e(o, l), _t2]).filter(Boolean) : [_t2].filter(Boolean);
  }
},
    y = function y(e) {
  var n, t;
  var l = f(e),
      o = null == e ? void 0 : null === (n = e.data) || void 0 === n ? void 0 : null === (t = n.parent) || void 0 === t ? void 0 : t.document;
  return (null == o ? void 0 : o.uid) ? v([y(o), l].filter(Boolean)) : [l].filter(Boolean);
},
    m = function m(e) {
  return [null].concat(_toConsumableArray(h(e)), [null]).join("/");
},
    b = function b(e) {
  return [null].concat(_toConsumableArray(y(e)), [null]).join("/");
},
    O = function O(n, t) {
  var l;
  return null === (l = e.parse(null == t ? void 0 : t.search)) || void 0 === l ? void 0 : l[n];
},
    j = function j(e) {
  return (null == e ? void 0 : e.text) ? null == e ? void 0 : e.html : void 0;
},
    w = function w(e, n) {
  var t = Object.keys(n),
      l = {};

  for (var _o = 0; _o < t.length; _o++) {
    var _r = t[_o],
        _e = e([_r, n[_r]]),
        _e2 = _slicedToArray(_e, 2),
        _i = _e2[0],
        _u = _e2[1];

    l[_i] = _u;
  }

  return l;
},
    _ = function _(e, n) {
  var t = d(e),
      l = d((null == n ? void 0 : n.pathname) || "");
  return !(!t.length || !l.length) && l.startsWith(t);
},
    P = function P(e, n) {
  return d(e) === d((null == n ? void 0 : n.pathname) || "");
},
    S = function S(e) {
  var n = new FormData(),
      t = Object.keys(e);

  for (var _l = 0; _l < t.length; _l++) {
    var _o2 = t[_l];
    n.append(_o2, e[_o2]);
  }

  return n;
},
    k = function k(e) {
  return Object.keys(e).reduce(function (n, t) {
    var l = e[t];
    return l && (n[t] = l), n;
  }, {});
},
    B = function B(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
  return Object.entries(e).reduce(function (e, l) {
    var _l2 = _slicedToArray(l, 2),
        o = _l2[0],
        r = _l2[1];

    return Array.isArray(r) ? e[o] = r[0] instanceof File ? r : r.toString() : n(r) ? e[o] = t ? JSON.stringify(r) : Object.keys(k(r)).toString() : e[o] = r, e;
  }, {});
},
    A = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, n, t) {
    var _l3, _o3, _r2;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            _l3 = function (e) {
              for (var n = 1; n < arguments.length; n++) {
                var t = null != arguments[n] ? arguments[n] : {};
                n % 2 ? u(t, !0).forEach(function (n) {
                  i(e, n, t[n]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : u(t).forEach(function (n) {
                  Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
                });
              }

              return e;
            }({
              "form-name": e
            }, n);

            t && (_l3["g-recaptcha-response"] = t);
            _context.next = 5;
            return fetch("/", {
              method: "post",
              body: S(_l3)
            });

          case 5:
            _o3 = _context.sent;
            _r2 = (null == _o3 ? void 0 : _o3.status) || 0;
            return _context.abrupt("return", _r2 >= 200 && _r2 < 300);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", (console.error(_context.t0), !1));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  }));

  return function A(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}(),
    D = function D(e) {
  return t(e);
},
    E = function E(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
      t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];

  var l = function l(e) {
    return n.includes(null == e ? void 0 : e.__typename);
  };

  return _toConsumableArray(t).reduce(function (n, o, r) {
    var i = t[r - 1];
    return l(o) && !l(i) ? [].concat(_toConsumableArray(n), [{
      __typename: e,
      id: D(e),
      slices: [o]
    }]) : l(o) ? (n[n.length - 1].slices = [].concat(_toConsumableArray(n[n.length - 1].slices), [o]), n) : [].concat(_toConsumableArray(n), [o]);
  }, []);
},
    F = function F(e) {
  return t(e);
},
    x = function x(e, n) {
  var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
      l = !1;
  return t.reduce(function (t, o) {
    var r = t[t.length - 1],
        i = (null == o ? void 0 : o.__typename) === n,
        u = (null == r ? void 0 : r.__typename) === e;
    return i && !u ? (l = !0, [].concat(_toConsumableArray(t), [{
      __typename: e,
      id: F(e),
      slices: [],
      startingSlice: o
    }])) : i && u ? (l = !1, r.endingSlice = o, t) : u && l ? (r.slices = [].concat(_toConsumableArray(r.slices), [o]), t) : [].concat(_toConsumableArray(t), [o]);
  }, []);
},
    C = function C(e) {
  var n;
  return (null == e ? void 0 : null === (n = e.data) || void 0 === n ? void 0 : n.main) || [];
},
    L = function L(e) {
  var n;
  return _toConsumableArray(new Set(null === (n = C(e)) || void 0 === n ? void 0 : n.map(function (e) {
    return null == e ? void 0 : e.__typename;
  })));
},
    q = function q(e, n) {
  return L(n).includes(e);
},
    I = function I(e, n) {
  return C(n).find(function (n) {
    return (null == n ? void 0 : n.__typename) === e;
  });
},
    J = function J(e) {
  return C(e)[0];
},
    M = function M(e) {
  return L(e)[0];
},
    N = function N(e) {
  var n = (e || "").match(/^(Prismic[A-Z].*Main)(.*)/);
  if (null == n ? void 0 : n.length) return l(n[n.length - 1]);
},
    W = function W(e) {
  return null == e ? void 0 : e.tags;
},
    Z = function Z(e, n) {
  return W(n).some(function (n) {
    return n.toLowerCase() === e.toLowerCase();
  });
},
    $ = function $(e) {
  var n, t;
  return null == e ? void 0 : null === (n = e.localFile) || void 0 === n ? void 0 : null === (t = n.childImageSharp) || void 0 === t ? void 0 : t.fluid;
},
    z = function z(e, n) {
  for (e >= (n = o(n)).length && (e = n.length - 1); e > -1 && (null === n[e] || void 0 === n[e]);) {
    e--;
  }

  return n[e];
},
    G = function G(e, n, t) {
  return void 0 === n && void 0 === t ? [!1] : r(null == n ? void 0 : n[e], null == t ? void 0 : t[e]);
},
    H = function H(e) {
  var n, t;
  var l = null == e ? void 0 : null === (n = e.data) || void 0 === n ? void 0 : null === (t = n.parent) || void 0 === t ? void 0 : t.document;
  return l ? v([H(l), e]) : [e];
};

export { y as arrayPathFor, S as createFormData, z as firstLeft, v as flatten, C as getAllMetadata, $ as getImageFluid, I as getMetadata, L as getMetadataTypes, g as getNormalizedSlug, f as getNormalizedUID, J as getPrimaryMetadata, M as getPrimaryMetadataType, j as getRichText, O as getSearchQuery, W as getTags, q as hasMetadataType, Z as hasTag, a as isBrowser, c as isInternal, _ as isPathActive, P as isPathActiveExact, h as linkResolverArrayPathFor, m as linkResolverPathFor, w as mapObj, N as metadataBasename, H as nodesPathFor, B as normalizeFormData, s as notEmpty, b as pathFor, A as postNetlifyForm, G as propPairsEq, E as zipAdjSlices, x as zipBetweenSlices };